import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Desk } from 'src/app/models/turns-models/desk.model';

@Component({
  selector: 'app-turns-desks-breadcrumb-filter-card',
  templateUrl: './turns-desks-breadcrumb-filter-card.component.html',
  styleUrls: ['./turns-desks-breadcrumb-filter-card.component.scss']
})
export class TurnsDesksBreadcrumbFilterCardComponent implements OnInit {

  @Input() desks;
  centers;
  types;
  centersForm = new FormGroup({});
  typesForm = new FormGroup({});

  constructor(private userStorageService: UserStorageService,
              private deskTurnsService: DesksTurnsService) { }

  ngOnInit() {
    this.getCenters();
    this.getTypes();
    if (this.userStorageService.getFilterDesks()) {
      this.centersForm.patchValue(this.userStorageService.getFilterDesks()['centersForm']);
      this.typesForm.patchValue(this.userStorageService.getFilterDesks()['typesForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterDesks({ centersForm: this.centersForm.getRawValue(), typesForm: this.typesForm.getRawValue() });
    if (this.userStorageService.getFilterDesks()['centersForm']['all'] && this.userStorageService.getFilterDesks()['typesForm']['all']) {
      this.userStorageService.deleteFilterDesks();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.desks.forEach((d: Desk) => {
      if (centers.indexOf(d.CenterName) === -1) {
        centers.push(d.CenterName);
        this.centersForm.addControl(d.CenterName, new FormControl(false));
      }
    });
    this.centers = centers;
  }

  private getTypes() {
    const types = new Array<string>();
    this.typesForm.addControl('all', new FormControl(true));
    this.desks.forEach((d: Desk) => {
      if (types.indexOf(d.TurnTypeInternalId) === -1) {
        types.push(d.TurnTypeInternalId);
        this.typesForm.addControl(d.TurnTypeInternalId, new FormControl(false));
      }
    });
    this.types = types;
  }

  public filter() {
    const forms = {
      centersForm:
      {
        attribute: 'CenterName',
        values: []
      },
      typesForm:
      {
        attribute: 'TurnTypeInternalId',
        values: []
      }
    };
    if (this.centersForm.get('all').value) {
      forms['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    } else {
      Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { forms['centersForm'].values.push(c[0]); }});
    }
    if (this.typesForm.get('all').value) {
      forms['typesForm'].values = Object.keys(this.typesForm.value).splice(1);
    } else {
      Object.entries(this.typesForm.value).forEach(c => { if (c[1]) { forms['typesForm'].values.push(c[0]); }});
    }
    this.deskTurnsService.filterDesks(forms);
  }
}
